import React from "react";

import { Notification } from "@jsainsburyplc/id-ui-common";

import { FAILURE_MESSAGE, TRY_AGAIN } from "constants/messages";

export const SubmitEmailFailure = () => (
  <div className="ln-u-text-align-center ln-u-margin-bottom*2">
    <Notification>
      {FAILURE_MESSAGE} {TRY_AGAIN}
      <br />
    </Notification>
  </div>
);
